export default __webpack_public_path__ + "static/media/mathsIcon.37222dc1.svg";